import React, { FunctionComponent, KeyboardEventHandler, MouseEventHandler } from "react";

import { bemClassNames } from "@multiweb/reactUtils";
import { IconCode } from "@multiweb/types/contracts";
import { Icon, IconColor, IconSize } from "../Icon";
import { Text, TextColor } from "../Text";

export type DocumentDownloadButtonComponentProps = {
    /** Název souboru */
    filename: string;
    /** Příznak, zda je tlačítko vizuálně neaktivní */
    disabled?: boolean;
    /** Callback volaný po kliknutí na tlačítko */
    onClick: MouseEventHandler<HTMLButtonElement>;
    /** Callback volán po stisku klávesy */
    onKeyPress: KeyboardEventHandler<HTMLButtonElement>;
};

const classNames = bemClassNames("document-download-button-component");

export const DocumentDownloadButtonComponent: FunctionComponent<DocumentDownloadButtonComponentProps> = ({
    filename,
    disabled = false,
    onClick,
    onKeyPress,
}) => (
    <button
        title={filename}
        className={classNames({ disabled })}
        {...{
            disabled,
            onClick,
            onKeyPress,
        }}
    >
        <Icon
            disabled={disabled}
            size={IconSize.small}
            iconCode={IconCode.docAttachment}
            color={IconColor.colorPrimary}
        />
        <span className={classNames("text", { disabled })}>
            <Text
                value={filename}
                disabled={disabled}
                color={TextColor.colorPrimary}
                ellipsis
            />
        </span>
    </button>
);
